import HiPayLogo from "../images/deposit/hipay-logo.svg";
import OctopayLogo from "../images/deposit/octopay-logo.png";
import PixLogo from "../images/deposit/pix-logo.png";

export const depositMethods = {
  hipay: {
    name: "BANCONTACT",
    logo: HiPayLogo,
  },

  octopay: {
    name: "OKTO PAY",
    logo: OctopayLogo,
  },

  pix: {
    name: "PIX",
    logo: PixLogo,
    needsLogin: false,
  },
  'pix-safeway': {
    name: "PIX SAFEWAY",
    logo: PixLogo,
    needsLogin: false,
  },
};
